import { ACTION, DeleteUserMessage, ErrorNotification } from './action-types';

export const removeAfter = 5000;

import get from 'lodash/get';
import { ApplicationState } from 'app/types-store';

export const userMessages = (store: Redux.Store<ApplicationState>) => (next: any) => (action: any) => {
  const errorMessages = get(action, 'error.userMessages');

  if (Array.isArray(errorMessages)) {

    errorMessages.forEach(m => {
      store.dispatch(new ErrorNotification(
        m.message
      ));
    });
  }

  if (action && !!action.message && action.type === ACTION.DISPLAY_USER_MESSAGE) {
  
    if (!!store.getState() && !!store.getState().app && Array.isArray(store.getState().app.messages)) {

      const isDuplicate = store.getState().app.messages.some(message => 
        message.message === action.message.message && message.type === action.message.type);
  
      if (isDuplicate) {
        return;
      }

    }

    /**
     * The UX is more consistent if we show and dispose messages, otherwise they might re-appear when re-rendering
     */
    setTimeout(() => {
      store.dispatch(new DeleteUserMessage(action.message));
    }, removeAfter);

  }

  next(action);
};
